import { gql } from "generated/gql"

export const GET_MARKETING_PLATFORMS_QUERY = gql(`
  query GetMarketingPlatforms {
    marketingPlatforms {
      ...MarketingPlatformFields
    }
  }
`)
